export default __webpack_public_path__ + "static/media/Primarylogomark_purple_black_white-01.4a85b0b6.webp";